/**
 * Get a wrapper array if the entry value is not an array. Utility to assure
 * that an unknown value can be read as an array.
 * @param {*} val - target value
 * @returns {Array} - Array
 */
function arrify(val) {
    return Array.isArray(val) ? val : [val];
}

/**
 * Returns the first item if the input is an array,
 * otherwise returns the value itself.
 *
 * This is useful when a value might be a single item or an array,
 * but you only want to work with the first item in either case.
 *
 * @param {*} value - Any value or an array of values.
 * @returns {*} The first item if it's an array, otherwise the original value.
 *
 * @example
 * firstOrSelf([{ id: 1 }, { id: 2 }]); // => { id: 1 }
 * firstOrSelf({ id: 1 });              // => { id: 1 }
 * firstOrSelf([]);                     // => undefined
 * firstOrSelf(null);                  // => null
 */
function firstOrSelf(value) {
    return Array.isArray(value) ? value[0] : value;
}

/**
 * Create a new Array that contains only non-duplicated values
 * @param {Array} arr Source array
 * @returns {Array} new array with unique values
 */
function removeDuplicates(arr) {
    if (!Array.isArray(arr)) throw new Error('Param must be an array');
    return arr.filter(function (element, index) {
        return arr.indexOf(element) === index;
    });
}

module.exports = {
    arrify: arrify,
    firstOrSelf: firstOrSelf,
    removeDuplicates: removeDuplicates
};
